import Icon from "../../../components/Icon/Icon";
import {ReactComponent as LogoSvg} from "../../../assets/logo.svg";
import "./PublicTemplate.scss"

const PublicTemplate = ({children}) => {
    return (
        <div className="public-template">
            <header>
                <p>
                    <span>Dealy</span><span>Docs</span>
                </p>
                <Icon svg={LogoSvg}/>
            </header>

            {children}
        </div>
    )
}

export default  PublicTemplate;